export default "__VITE_ASSET__e89e533e__"